import { IconLike, IconLikeOutline } from "assets/icons";
import THEME from "constants/themes";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import utils from "services/utils";
import { galleryVotingRequest } from "stores/actions";
import { StyledSection } from "styled-components/CommonStyled";
import {
  StyledVoteContainer,
  StyledVoteIcon,
} from "styled-components/CustomGallery/ContentDetailStyled";

const ContentVoting = (props) => {
  const { t } = useTranslation();
  const { content, setContentList, contentList, globalInfo } = props;
  const { publicIsVoted, publicVoteCount } = content.review;
  const dispatch = useDispatch();
  const location = useLocation();
  const { search = "" } = location;
  const clientId = globalInfo?.clientIdGlobal || utils.getClientId(search);

  const voting = useMemo(() => {
    return {
      count: publicVoteCount,
      text: t(publicIsVoted ? "voted" : "add_your_vote"),
      icon: publicIsVoted ? <IconLike /> : <IconLikeOutline />,
    };
  }, [publicIsVoted, publicVoteCount]);

  const handleVoting = () => {
    const contentListTemp = [...contentList];
    const contentIdx = contentList.findIndex((item) => item.id === content.id);
    contentListTemp[contentIdx].review.publicVoteCount =
      publicVoteCount + (!publicIsVoted ? 1 : -1);
    contentListTemp[contentIdx].review.publicIsVoted = !publicIsVoted;
    setContentList(contentListTemp);
    dispatch(
      galleryVotingRequest({
        clientId,
        contentId: content.id,
        unVote: publicIsVoted,
      })
    );
  };

  return (
    <StyledVoteContainer>
      <StyledSection
        background={THEME.colors.darkBlue1}
        height="100%"
        padding="0 8px"
        color={THEME.colors.white}
        lineHeight="34px"
        minWidth="34px"
        textAlign="center"
      >
        {voting.count}
      </StyledSection>
      <StyledSection
        background={THEME.colors.white}
        height="100%"
        padding="0 8px"
        lineHeight="34px"
        display="flex"
        cursor="pointer"
        color={THEME.colors.darkBlue1}
        onClick={handleVoting}
        tabIndex={0}
      >
        {voting.text}
        <StyledVoteIcon size="16" margin="-1px 0 0 4px">
          {voting.icon}
        </StyledVoteIcon>
      </StyledSection>
    </StyledVoteContainer>
  );
};

export default ContentVoting;
